import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import OutlierDetectionTaskEditDto from '../dto/OutlierDetectionTaskEditDto';

class OutlierDetectionTaskEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.PARENT_CONTROL = 'taskManagerControl';
		this.CONTROL = 'outlierDetectionTaskEditControl';
	}

	/**
	 * @return {Promise<OutlierDetectionTaskEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new OutlierDetectionTaskEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} type
	 * @return {Promise<OutlierDetectionTaskEditDto>}
	 */
	createByType(type) {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new OutlierDetectionTaskEditDto().setup({ ...response.data, type })))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<OutlierDetectionTaskEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new OutlierDetectionTaskEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {OutlierDetectionTaskEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, { dto })
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {OutlierDetectionTaskEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new OutlierDetectionTaskEditService();